import { Reveal } from "./Reveal";
import { marginExample as m } from "@/data/numbers";
import { useLeadModal } from "@/context/LeadModalContext";

const eur = (n) => `${n}€`;

const Figure = ({ label, value, accent, testid }) => (
  <div data-testid={testid}>
    <p className="font-sans-ui text-[10px] tracking-mega text-ink/45 mb-2">{label}</p>
    <p className={`font-display font-light leading-none text-4xl sm:text-5xl lg:text-6xl ${accent ? "text-goldtan" : "text-ink"}`}>{value}</p>
  </div>
);

export const MarginExample = () => {
  const { openModal } = useLeadModal();
  const saleMin = m.mboPrice * m.markupMin;
  const saleMax = m.mboPrice * m.markupMax;
  return (
    <section className="bg-ivory pt-4 pb-20 sm:pt-8 sm:pb-28" data-testid="margin-example">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
        <Reveal>
          <div className="bg-ink text-ivory p-8 sm:p-12 lg:p-14 grid lg:grid-cols-[1fr_2fr] gap-10 lg:gap-16 items-center">
            <div>
              <p className="font-sans-ui text-[10px] tracking-mega text-goldtan mb-4">ESEMPIO PRATICO</p>
              <h3 className="font-display font-light text-3xl sm:text-4xl leading-tight">
                {m.productName} <span className="text-ivory/40 text-xl align-middle ml-1">{m.productCode}</span>
              </h3>
              <p className="mt-4 font-sans-ui text-sm text-ivory/60 leading-relaxed">
                Ricarico reale x{m.markupMin}–x{m.markupMax} sul prezzo di acquisto My Brand Online.
              </p>
              <button onClick={openModal} data-testid="margin-example-cta" className="mt-6 inline-flex items-center bg-ivory text-ink px-6 py-3 text-[10px] tracking-mega font-medium hover:bg-goldtan transition-colors">
                CALCOLA IL TUO MARGINE
              </button>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 sm:gap-6 border-t lg:border-t-0 lg:border-l border-ivory/15 pt-8 lg:pt-0 lg:pl-14 [&_p]:text-ivory [&_.text-ink\\/45]:text-ivory/45">
              <Figure label="PREZZO MY BRAND ONLINE" value={eur(m.mboPrice)} testid="margin-mbo-price" />
              <Figure label="PREZZO DI VENDITA CONSIGLIATO" value={`${eur(saleMin)} – ${eur(saleMax)}`} testid="margin-sale-price" />
              <Figure label="IL TUO MARGINE A PEZZO" value={`${eur(saleMin - m.mboPrice)} – ${eur(saleMax - m.mboPrice)}`} accent testid="margin-profit" />
            </div>
          </div>
        </Reveal>
        <Reveal delay={0.05}>
          <p className="mt-4 font-sans-ui text-[11px] text-ink/45 italic">{m.disclaimer}</p>
        </Reveal>
      </div>
    </section>
  );
};
